/* eslint-disable react/no-array-index-key */

import React from 'react';
import moment from 'moment';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import withStyles from '@mui/styles/withStyles';
import { getEvent } from '@pingum/app-state-management/event/actions';
import { getStatuses } from '@pingum/app-state-management/status/actions';
import Grid from '@mui/material/Grid';
import HistoryItem from '../HistoryItem';
import AddCommentCard from '../AddCommentCard';

import styles from './styles';

export class EventDetailPageComponent extends React.Component {
  render() {
    const {
      selectedEvent,
      tenantUsers,
      showActionCard,
      classes,
    } = this.props;

    const eventStatuses = selectedEvent.eventStatus || [];
    const comments = selectedEvent.comments || [];
    const eventUploads = selectedEvent.eventUploads || [];

    const historyItems = [
      ...eventStatuses.sort((a, b) => a.id - b.id).map((eventStatus, index) => ({
        ...eventStatus,
        type: 'eventStatus',
        nextEventStatus: eventStatuses[index + 1] || {},
      })),
      ...eventUploads.map((eventUpload) => ({
        ...eventUpload,
        type: 'eventUpload',
      })),
      ...comments
        .filter((comment) => comment.commentHeader.indexOf('New Status For Event') === -1)
        .map((comment) => ({
          ...comment,
          type: 'comment',
        })),
    ].sort((a, b) => moment(b.createdDate).unix() - moment(a.createdDate).unix());

    return (
      <Grid container spacing={2} justifyContent="space-between">
        <Grid sx={{ maxHeight: 500 }} size={12}>
          <Box
            sx={{
              position: 'relative',
              overflow: 'auto',
              height: '100%',
            }}
          >
            {
            showActionCard && <Grid size={12}><AddCommentCard /></Grid>
          }
            <div className={classes.container}>
              {
                historyItems
                  .map((historyItem, index) => (
                    <HistoryItem
                      key={`history-item-${historyItem.type}-${historyItem.id}-${index}`}
                      item={historyItem}
                      tenantUsers={tenantUsers}
                    />
                  ))
              }
            </div>
          </Box>
        </Grid>
      </Grid>
    );
  }
}

EventDetailPageComponent.propTypes = {
  selectedEvent: PropTypes.object,
  tenantUsers: PropTypes.array,
  showActionCard: PropTypes.bool,
  classes: PropTypes.object,
};

EventDetailPageComponent.defaultProps = {
  selectedEvent: {},
  tenantUsers: [],
  showActionCard: false,
  classes: {},
};

export const mapStateToProps = (state) => ({
  selectedEvent: state.event.selectedEvent,
  statuses: state.status.statuses,
  tenantUsers: state.barn.barnUsers,
});

export const mapDispatchToProps = (dispatch) => ({
  getEvent: (id) => dispatch(getEvent(id)),
  getStatuses: () => dispatch(getStatuses()),
});

export default withStyles(styles)(connect(
  mapStateToProps,
  mapDispatchToProps,
)(EventDetailPageComponent));
